import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseButton } from '../../../../../../BaseComponents';
import { useRemoveLastSelectedFlight } from '../../model/useRemoveLastSelectedFlight';

interface Props {
	label?: string;
}

const RemoveLastSelectedFlightButton: React.FC<Props> = ({ label }) => {
	const { t } = useTranslation('Exchange');

	const { onRemoveLastSelectedFlight } = useRemoveLastSelectedFlight();

	return (
		<BaseButton variant="text" onClick={onRemoveLastSelectedFlight}>
			{label || t('RemoveLastSelectedFlightButton.Label')}
		</BaseButton>
	);
};

export default RemoveLastSelectedFlightButton;
